/**
 * Checklist cevap gösterimi — mobil CompletedAppointmentDetailScreen ile uyumlu.
 */
export const formatChecklistCevapGosterim = (row) => {
  const cevap = String(row?.cevap || '').trim();
  const cevapLower = cevap.toLowerCase();
  const isEvet = cevapLower === 'evet' || row?.cevapRaw === 'evet';
  const deger = row?.deger != null ? String(row.deger).trim() : '';
  const birim = row?.degerBirimi != null ? String(row.degerBirimi).trim() : '';

  if (isEvet && deger) {
    return birim ? `Evet — ${deger} ${birim}` : `Evet — ${deger}`;
  }
  if (cevap) return cevap;
  if (row?.cevapRaw === 'evet') return 'Evet';
  if (row?.cevapRaw === 'hayir') return 'Hayır';
  return '—';
};

export const formatChecklistCevapFromTamamlama = (cevapRaw, deger, degerBirimi) => {
  const c = String(cevapRaw || '').trim().toLowerCase();
  if (c === 'evet') {
    const d = deger != null ? String(deger).trim() : '';
    if (d) {
      const birim = degerBirimi != null ? String(degerBirimi).trim() : '';
      return birim ? `Evet — ${d} ${birim}` : `Evet — ${d}`;
    }
    return 'Evet';
  }
  if (c === 'hayir') return 'Hayır';
  return cevapRaw ? String(cevapRaw) : '—';
};
